module.exports = __webpack_public_path__ + "static/img/code_2.580f352.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/code_2.png
// module id = Wu2e
// module chunks = 1